module.exports = __webpack_public_path__ + "static/media/PWA_Politics.584dd24b.jpg";